module.exports = __webpack_public_path__ + "static/gerenciamentoProdutos-259f21cf0f2c2913723b9aa3681d0b33.png";